import { render } from "./AiTesting.vue?vue&type=template&id=96603d0c&scoped=true&lang=pug"
import script from "./AiTesting.js?vue&type=script&lang=js&external"
export * from "./AiTesting.js?vue&type=script&lang=js&external"

import "./AiTesting.vue?vue&type=style&index=0&id=96603d0c&lang=scss&scoped=true"
import "./AiTesting.vue?vue&type=style&index=1&id=96603d0c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96603d0c"]])

export default __exports__